<template>
  <w-dialog @close="close()" :title="porjectInf.name" :show="MemberShow" :wallStyle="{zIndex: 2001}" :box-style="{width: '500px', zIndex: 2001}">
    <div class="person-dialog-addbox" v-if="state===1">
      <!--<div class="title" :title="porjectInf.name">-->
        <!--{{porjectInf.name}}-->
        <!--<a class="close w-icon-guanbi" @click="close"></a>-->
      <!--</div>-->
      <template v-if="tab===1">
        <div class="person-dialog-cnt">
          <w-row>
            <label class="margin-right-10" for="expire">链接有效期</label>
            <w-select size="small" v-model="selectOption" placeholder="请选择">
              <w-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </w-option>
            </w-select>
            <!--<div name="expire" id="expire" @click="optionShow = !optionShow">-->
              <!--{{selectOption}}-->
              <!--<i :class="[optionShow?'w-icon-xiala' : 'w-icon-xiala-copy' ,'icon-option']"></i>-->
            <!--</div>-->
            <!--<ul v-show="optionShow">-->
              <!--<li v-for="value in options" :key="value" @click="selectHandle(value)" :class="['option-li',selectOption===value?'option-li-selected':'']">-->
                <!--{{value}}-->
              <!--</li>-->
            <!--</ul>-->
          </w-row>
        </div>
        <div class="text-align-right">
          <w-button type="primary" @click="confirm">创建链接</w-button>
          <w-button type="minor" @click="close(100113066)">取消</w-button>
        </div>
      </template>
      <template v-else>
        <w-row class="person-dialog-cnt">
            <p class="time-title">时间：{{selectOption}}有效</p>
            <div class="time-title">
              <div class="inline-block margin-right-10" style="width: calc(100% - 100px);">
                <w-input size="small" id="inputValue" type="text" :value="inputValue" style="width: 100%;" />
              </div>
              <w-button type="primary" class="url-copy" @click="copyHandle" data-clipboard-action="copy"  data-clipboard-target="#inputValue">复制链接</w-button>
            </div>
            <p v-show="isCopy" class="error-message">
              {{message}}
            </p>
          </w-row>
          <div class="text-align-right">
            <w-button type="minor" @click="close(100113069)">取消</w-button>
          </div>
      </template>
    </div>
    <!--
    <div class="person-dialog-result person-dialog-ok" v-else-if="state===2">
      <a class="close w-icon-guanbi" @click="close()"></a>
      <em class="circle-color">
        <i class="color-wancheng1 w-icon-wancheng1">
        </i>
      </em>
      <p>
        分享成功
      </p>
    </div>

    -->
    <div class="person-dialog-result person-dialog-fail" v-else>
      <a class="close w-icon-guanbi" @click="close()"></a>
      <em class="circle-color">
        <i class="color-shibai w-icon-shibai">
        </i>
      </em>
      <p>
        分享失败，请稍后再试
      </p>
    </div>
  </w-dialog>
</template>

<script>
import SpaceService from '@/assets/service/space'
import { getCookie } from '@/assets/utils/CommonUtil'
import Clipboard from 'clipboard'
export default {
  data () {
    return {
      state: 1,
      user: {},
      message: '',
      options: [
        {label: '1天', value: '1天'},
        {label: '7天', value: '7天'},
        {label: '永久', value: '永久'}
      ],
      // options: ['1天', '7天', '永久'],
      // optionShow: false,
      selectOption: '永久',
      workspaceId: getCookie('personalWorkspaceIdValue'),
      tab: 1,
      isCopy: false,
      inputValue: ''
    }
  },
  props: {
    MemberShow: Boolean,
    porjectInf: Object
  },
  computed: {
    expireTime: function (){
      if (this.selectOption === '1天'){
        return 86400000
      } else if (this.selectOption === '7天'){
        return 86400000 * 7
      } else {
        return null
      }
    }
  },
  methods: {
    confirm () {
      this.sendShareData()
    },
    close (logCode) {
      if (logCode) {
        // 创建链接、复制链接 弹窗取消按钮点击
        this.sentLog(logCode)
      } else {
        // 创建链接、复制链接 弹窗关闭按钮点击
        this.sentLog(this.tab === 1 ? 100113067 : 100113070)
      }
      this.$emit('cancel')
    },
    sendShareData (data){
      const { suffix, fileId, path, length } = this.porjectInf
      const type = this.expireTime ? (this.expireTime / 86400000) : 8
      let params = {
        workspaceId: this.workspaceId,
        fileId,
        filePath: path,
        expireTime: this.expireTime,
        receiverList: data
      }
      SpaceService.sendSharePersonMessages(params).then(res => {
        if (+res.code === 200) {
          this.sentLog(100113065, {files: [{status: 1, suffix, fileId, length}], length, status: 1, type})
          this.tab = 2
          this.inputValue = res.data
        } else {
          this.sentLog(100113065, {files: [{status: 1, suffix, fileId, length}], length, status: 0, type, code: res.code})
          this.state = 3
        }
      }).catch(() => {
        this.sentLog(100113065, {files: [{status: 1, suffix, fileId, length}], length, status: 0, type})
        this.state = 3
      })
    },
    // 选择期限
    // selectHandle(data){
    //   this.selectOption = data
    //   this.optionShow = false
    // },
    // 复制
    copyHandle (){
      this.sentLog(100113068)
      let clipboard = new Clipboard('.url-copy')
      clipboard.on('success', () => {
        this.isCopy = true
        this.message = '链接已复制，您可以打开qq、微信等工具进行粘贴并分享工程!'
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', () => {
        this.isCopy = true
        this.message = '该浏览器不支持自动复制!'
        // 释放内存
        clipboard.destroy()
      })
    }
  },
  created () {
    let userinfo = getCookie('ZJYUSERINFO')
    if (userinfo){
      userinfo = JSON.parse(userinfo)
      this.user = userinfo
    }
  }
}
</script>

<style  lang="less">
.person-dialog{
  width: auto!important;
  animation-duration: 0s!important;
}
.person-dialog-addbox {
  background: #fff;
  font-size: 14px;
  color: rgba(102,102,102,1);
  .error-blue{
    width:84px;
    height:16px;
    padding: 10px;
    font-size:12px;
    color:rgba(64,158,255,1);
    line-height:16px;
  }
  #expire{
    display: inline-block;
    position: relative;
    border-radius: 5px;
    border: 1px solid #D3D3D3;
    width: 147px;
    height: 30px;
    margin-left: 16px;
    line-height: 30px;
    padding-left: 15px;
    .icon-option{
      position: absolute;
      right: 10px;
      top: 0px;
    }
  }
  .person-dialog-cnt {
    min-height: 120px;
  }
  .time-title{
    padding-bottom: 10px;
    color: #666;
  }
  .error-message{
    padding-top: 20px;
    height: 16px;
    line-height: 16px;
    font-size:12px;
    color:rgba(102,102,102,1);
    color: #666;
  }
}
.person-dialog-result {
  width: 400px;
  height: 238px;
  box-sizing: border-box;
  position: relative;
  background: #fff;
  border-radius: 5px;
  font-size: 24px;
  line-height: 80px;
  text-align: center;
  padding-top: 50px;
  &.person-dialog-fail{
    color: #e33b34;
    .circle-color{
      width: 90px;
      height: 90px;
      background: #e43931;
      display: inline-block;
      border-radius: 50%;
    }
  }
  &.person-dialog-ok{
    color: #4595ed;
    .circle-color{
      width: 90px;
      height: 90px;
      background: #4391fb;
      display: inline-block;
      border-radius: 50%;
      color: blue;
    }
  }
  .color-wancheng1{
    line-height: 90px;
    font-size: 100px;
    color: #4192fa;
    background: #fff;
  }
  .color-shibai{
    line-height: 90px;
    font-size: 100px;
    color: #e53932;
    background: #fff;
  }
  .close {
    position: absolute;
    right: -15px;
    top: -5px;
    transform: translateY(-50%);
    cursor: pointer;
    color: #cdcfd3;
    &:hover {
      color: #333;
    }
  }
}
</style>
